<template>
  <modal name="terms-modal" class="terms-modal"
         :width="'91.54%'"
         :height="'auto'"
         :transition="`modal-bottom`"
         @before-open="handlerBeforeOpen"
         @before-close="handlerBeforeClose"
         @opened="handlerOpened"
  >
    <div class="terms-modal_wrap">
      <div class="terms-modal_content">
        <div class="terms-modal_content_title" >{{returnTermsName()}}</div>
        <terms-component class="terms-modal_content_text" :termsType="termsType"></terms-component>
      </div>
      <div class="terms-modal_bottom" @click="close()">
        <button class="confirm_btn">확인</button>
      </div>
    </div>
  </modal>
</template>

<script>
import TermsComponent from "@/components/terms/TermsComponent";

export default {

  name: "TermsModal",
  mixins: [],
  components: {
    TermsComponent
  },
  props: {},
  data() {
    return {
      termsType: '',
        scroll:''
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    handlerBeforeOpen(event) {
      this.termsType = event.params.termsType;
      if (!this.termsType) {
        event.stop()
      }
      this.scroll = event.params.scroll
      document.body.classList.add('modal_open')
      document.body.style.top = `-${this.scroll}px`
    },
    handlerOpened(event) {
      // document.body.style.overflow = 'hidden'
    },
    handlerBeforeClose(event) {
      document.body.classList.remove('modal_open')
      document.body.style.removeProperty('top');

      window.scrollTo(0,this.scroll)
    },
    close() {
      this.$modal.hide('terms-modal');
    },
    returnTermsName() {
      if (this.termsType === 'stipulation') {
        return '서비스이용약관'
      }
      if (this.termsType === 'privacy') {
        return '개인정보처리방침'
      }
    }
  },
  watch: {},
}
</script>

<style lang="scss">
.editor {
    margin: 24px 0;
    padding: 20px;
    background-color: #eaeaea;
  max-width: 100%;
  pre {
    overflow-x: initial;
    white-space: inherit;
  }
}
</style>
